/* eslint-disable no-unused-vars */
import { axios } from './index'
import getPrefJSON from "../constants/prefData.js";

const resource = '/v1/stay'

export default {
  searchPlan(params) {
    // console.log('**************************************************')
    // console.log(JSON.stringify(params))
    // return Repository.get(`${resource}/plan`, { params })
    return axios.get(`${resource}/search/plan`, { params })
  },
  searchMenu(body, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/search/menu`, body, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },
  searchMenuList(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/menu-list`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  /* ========= PUBLIC STAY ========= */
  searchMenuPublicStay(body, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/search/public/stay`, body, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  getCodesArea(params) {
	//return getCodesAreaJSON(params);
	//console.log(axios.get(`${resource}/codes/area`, { params }));
    return axios.get(`${resource}/codes/area`, { params });
  },

  async getLargeCodesArea() {
    return getPrefJSON();
  },

}
